module.exports = __webpack_public_path__ + "1a64f9c0366e498838b5bfc60e88a97b.gltf";